import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirdicabbookingpackages() {



    const cardData = {





keyword: "Shirdi Cab Packages",

headingDescription: "Sai Shirdi Cab offers flexible Shirdi Cab Packages for devotees, families, tourists, senior citizens, corporate travelers, and groups planning outstation journeys from Shirdi. Customers can choose private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way travel, round trips, full-day rentals, multi-day tours, pilgrimage packages, family vacations, and customized sightseeing itineraries. Cab packages can be planned according to the number of passengers, travel duration, destinations, luggage requirements, and preferred pickup and drop locations. Travelers can combine multiple destinations in one itinerary instead of arranging separate transportation for every leg of the journey. With experienced drivers, clean and well-maintained cars, comfortable seating, sufficient luggage space, flexible schedules, and convenient hotel or residence pickups, Sai Shirdi Cab makes outstation travel easier to organize. Customers can also customize packages for Maharashtra, Madhya Pradesh, Gujarat, Goa, and other nearby destinations according to their travel plans.",

topPlaces: [
{
title: "Pune",
description: "Pune is a popular destination for travelers booking cab packages from Shirdi for business trips, family visits, tourism, education, and medical travel. Customers can combine Pune with nearby sightseeing destinations in a customized package. One-way and round-trip options are available with flexible pickup and drop arrangements."
},
{
title: "Mumbai",
description: "Mumbai is a major outstation destination from Shirdi and can be included in a customized cab package for business, tourism, family visits, and airport travel. Travelers can choose direct or multi-stop itineraries according to their requirements. Spacious vehicles are suitable for families and groups with luggage."
},
{
title: "Nashik",
description: "Nashik is a convenient destination for a Shirdi cab package and is popular for pilgrimage, sightseeing, business, and family travel. Customers can combine Nashik with nearby religious and tourist attractions in one itinerary. Private cab packages provide flexibility over departure times and sightseeing duration."
},
{
title: "Chhatrapati Sambhajinagar",
description: "Chhatrapati Sambhajinagar is a major heritage destination that can be included in a Shirdi outstation cab package. Travelers can plan visits to historical attractions and combine the city with nearby destinations. Private transportation provides comfortable travel for families, tourists, and groups."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular hill station suitable for customized family and holiday cab packages from Shirdi. Travelers can plan a multi-day trip with convenient hotel transfers and sightseeing stops. Comfortable vehicles such as Ertiga, Innova, and Innova Crysta are suitable for longer journeys."
},
{
title: "Lonavala",
"description": "Lonavala is a scenic destination that can be included in a Shirdi cab package for weekend holidays and family vacations. Customers can customize the itinerary with nearby viewpoints and attractions. Round-trip and multi-day packages allow travelers to explore the destination without depending on fixed public transport."
},
{
title: "Kolhapur",
"description": "Kolhapur is an important Maharashtra destination known for temples, heritage, culture, and local attractions. Travelers can include Kolhapur in an extended Shirdi cab package for religious or family travel. Private transportation offers flexible routing and convenient hotel or residence drops."
},
{
title: "Solapur",
"description": "Solapur is a popular outstation destination from Shirdi for business, family visits, and religious travel. Customers can select a one-way or round-trip cab package based on their schedule. Spacious vehicles provide comfortable transportation for families and groups undertaking longer journeys."
},
{
title: "Indore",
"description": "Indore is a major Madhya Pradesh destination that can be included in a long-distance Shirdi cab package. Travelers can book private transportation for business, family visits, tourism, or onward travel. Multi-day packages can also be customized to include nearby destinations around Indore."
},
{
title: "Ujjain",
"description": "Ujjain is an important pilgrimage destination and can be combined with Indore in a customized Shirdi cab package. Devotees can plan a multi-destination religious journey with flexible temple visit timings. Private cab travel is convenient for families and groups who want direct transportation throughout the itinerary."
},
{
title: "Goa",
"description": "Goa is a popular long-distance holiday destination that can be included in a multi-day cab package from Shirdi. Travelers can customize the journey for beach holidays, family vacations, hotel transfers, and sightseeing. Private cars provide comfortable transportation with luggage space throughout the trip."
},
{
title: "Bhimashankar",
"description": "Bhimashankar is a prominent pilgrimage destination in Maharashtra and can be included in a religious cab package from Shirdi. Devotees can combine the destination with other temple visits and plan a customized round trip. Private transportation offers flexibility for families and pilgrimage groups."
},
{
title: "Trimbakeshwar",
"description": "Trimbakeshwar is a renowned Jyotirlinga destination near Nashik and can be added to a customized Shirdi pilgrimage cab package. Travelers can combine Trimbakeshwar with Nashik and other religious attractions in one journey. Flexible private cab service makes multi-destination travel convenient."
}
],








"services": [
{
"name": "Shirdi Cab Packages",
"description": "Shirdi Cab Packages provide convenient private transportation options for travelers planning local sightseeing, pilgrimage visits, airport transfers, and outstation journeys from Shirdi. Packages can be arranged according to passenger count, travel duration, vehicle category, pickup location, destinations, and customized itinerary requirements."
},
{
"name": "Shirdi Taxi Packages",
"description": "Shirdi Taxi Packages offer organized private taxi transportation for individuals, families, and groups visiting Shirdi and nearby destinations. Travelers can plan suitable packages based on the number of passengers, sightseeing requirements, travel dates, vehicle preference, and one-way or round-trip needs."
},
{
"name": "Shirdi Cab Tour Packages",
"description": "Shirdi Cab Tour Packages are suitable for travelers looking to explore Shirdi and surrounding attractions using private transportation. Tour plans can include temple visits, sightseeing locations, nearby destinations, multiple stops, and return travel according to the preferred itinerary."
},
{
"name": "Shirdi Taxi Tour Packages",
"description": "Shirdi Taxi Tour Packages provide private transportation for travelers planning sightseeing and pilgrimage tours from Shirdi. The package can be organized according to travel duration, selected destinations, passenger requirements, vehicle category, pickup point, and preferred return schedule."
},
{
"name": "Shirdi Sightseeing Cab Package",
"description": "Shirdi Sightseeing Cab Package provides private transportation for visitors exploring popular attractions in and around Shirdi. Customers can plan the package according to sightseeing locations, travel time, passenger count, vehicle type, pickup point, and the number of destinations included."
},
{
"name": "Shirdi Darshan Cab Package",
"description": "Shirdi Darshan Cab Package offers convenient transportation for passengers visiting Sai Baba Temple and other nearby pilgrimage locations. Cab arrangements can be planned for individuals, families, and groups with suitable vehicles based on passenger capacity, travel schedule, and sightseeing requirements."
},
{
"name": "Shirdi Sai Baba Darshan Cab Package",
"description": "Shirdi Sai Baba Darshan Cab Package provides private transportation for devotees planning Sai Baba darshan in Shirdi. The package can be arranged with convenient pickup and drop options along with transportation to nearby temples and pilgrimage destinations according to the travel plan."
},
{
"name": "Shirdi Local Sightseeing Package",
"description": "Shirdi Local Sightseeing Package provides private cab transportation for travelers interested in exploring attractions within and around Shirdi. The itinerary can be customized for temple visits, local landmarks, nearby sightseeing points, shopping areas, and other destinations based on available travel time."
},
{
"name": "Shirdi One Day Cab Package",
"description": "Shirdi One Day Cab Package is designed for travelers planning a short private trip covering Shirdi and selected nearby destinations within a single day. The package can include multiple sightseeing stops and transportation according to passenger count, vehicle category, and preferred schedule."
},
{
"name": "Shirdi Two Day Cab Package",
"description": "Shirdi Two Day Cab Package provides private transportation for travelers planning a longer sightseeing or pilgrimage itinerary. Customers can organize the journey across two days with suitable vehicle options, multiple destinations, sightseeing stops, and return arrangements based on their travel requirements."
},
{
"name": "Shirdi Outstation Cab Package",
"description": "Shirdi Outstation Cab Package provides private transportation for travelers planning journeys from Shirdi to other cities and destinations. Packages can be arranged for one-way or round-trip travel according to route, passenger count, vehicle category, travel dates, luggage, and itinerary requirements."
},
{
"name": "Shirdi Family Cab Package",
"description": "Shirdi Family Cab Package offers comfortable private transportation for families traveling for pilgrimage, sightseeing, or outstation trips. Suitable vehicles can be selected according to family size, luggage requirements, travel duration, destinations, and preferred one-way or return itinerary."
},
{
"name": "Shirdi Pilgrimage Cab Package",
"description": "Shirdi Pilgrimage Cab Package provides private transportation for devotees visiting Shirdi and other religious destinations. The itinerary can be planned around temple visits, darshan schedules, nearby pilgrimage locations, passenger requirements, travel duration, and suitable vehicle options."
},
{
"name": "Shirdi Airport Cab Package",
"description": "Shirdi Airport Cab Package provides private airport transportation for passengers traveling between Shirdi Airport and their preferred destination. The package can be arranged for airport pickup or drop with suitable vehicles according to flight timing, passenger count, luggage, and destination requirements."
},
{
"name": "Shirdi to Shani Shingnapur Cab Package",
"description": "Shirdi to Shani Shingnapur Cab Package offers private transportation for travelers planning a pilgrimage visit to Shani Shingnapur from Shirdi. The package can be organized for one-way or return travel with suitable vehicles based on passenger count, travel timing, and darshan requirements."
},
{
"name": "Shirdi to Trimbakeshwar Cab Package",
"description": "Shirdi to Trimbakeshwar Cab Package provides private transportation for devotees and travelers visiting Trimbakeshwar from Shirdi. The trip can be arranged as a one-way or round-trip journey with suitable sedan, SUV, or larger vehicle options according to passenger requirements."
},
{
"name": "Shirdi to Nashik Cab Package",
"description": "Shirdi to Nashik Cab Package offers convenient private transportation for passengers traveling between Shirdi and Nashik. Customers can plan the package for local sightseeing, temple visits, airport or railway station transfers, business travel, or return journeys based on their itinerary."
},
{
"name": "Shirdi to Ajanta Ellora Cab Package",
"description": "Shirdi to Ajanta Ellora Cab Package provides private transportation for travelers planning to visit the famous Ajanta and Ellora Caves from Shirdi. The package can include sightseeing stops and return transportation with a suitable vehicle selected according to passenger count, luggage, and trip duration."
},
{
"name": "Shirdi to Mumbai Cab Package",
"description": "Shirdi to Mumbai Cab Package provides private intercity transportation for travelers journeying between Shirdi and Mumbai. The package can be planned for one-way travel, round trips, airport transfers, family trips, pilgrimage travel, or customized itineraries with a suitable vehicle category."
},
{
"name": "Shirdi to Pune Cab Package",
"description": "Shirdi to Pune Cab Package offers private transportation for passengers traveling from Shirdi to Pune for personal, family, business, airport, or pilgrimage-related requirements. Customers can choose suitable vehicle options and plan one-way or return transportation according to their travel schedule."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides private cab, taxi, and car rental options for local sightseeing, Sai Baba darshan, pilgrimage tours, airport transfers, and outstation journeys from Shirdi. Suitable sedan, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other vehicles can be arranged according to the selected package and passenger requirements."
}
],
"tableData": [
["Shirdi Cab Packages", "Shirdi Taxi Packages"],
["Shirdi Cab Tour Packages", "Shirdi Taxi Tour Packages"],
["Shirdi Sightseeing Cab Package", "Shirdi Darshan Cab Package"],
["Shirdi Sai Baba Darshan Cab Package", "Shirdi Local Sightseeing Package"],
["Shirdi One Day Cab Package", "Shirdi Two Day Cab Package"],
["Shirdi Outstation Cab Package", "Shirdi Family Cab Package"],
["Shirdi Pilgrimage Cab Package", "Shirdi Airport Cab Package"],
["Shirdi to Shani Shingnapur Cab Package", "Shirdi to Trimbakeshwar Cab Package"],
["Shirdi to Nashik Cab Package", "Shirdi to Ajanta Ellora Cab Package"],
["Shirdi to Mumbai Cab Package", "Shirdi to Pune Cab Package"],
["Sai Shirdi Cabs", "Shirdi Cab Packages"]
]
,






    whychoose: [
        { 
            WhyChooseheading: "Flexible Shirdi Cab Packages for Pilgrimage & Sightseeing", 
            WhyChoosedescription: "Sai Shirdi Cabs offers private cab packages in Shirdi for devotees, families, tourists, senior citizens, couples, and groups. Choose a suitable package for Sai Baba Darshan, local sightseeing, nearby pilgrimage destinations, airport transfers, or customized outstation travel according to your itinerary." 
        }, 
        { 
            WhyChooseheading: "Packages Designed for Different Travel Plans", 
            WhyChoosedescription: "Select a cab package based on your destination, number of passengers, travel duration, sightseeing requirements, and preferred vehicle. Whether you need a short local trip or a multi-day outstation journey, the itinerary can be planned around your requirements." 
        }, 
        { 
            WhyChooseheading: "Shirdi Darshan & Local Sightseeing Packages", 
            WhyChoosedescription: "Plan a private cab package for Sai Baba Darshan along with nearby Shirdi sightseeing. Families and devotees can travel together and organize temple visits, local attractions, hotel transfers, and other planned stops conveniently." 
        }, 
        { 
            WhyChooseheading: "Outstation Cab Packages from Shirdi", 
            WhyChoosedescription: "Travellers can arrange private cab packages from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Trimbakeshwar, Shani Shingnapur, Bhimashankar, and other pilgrimage or tourist locations according to their travel plans." 
        }, 
        { 
            WhyChooseheading: "One-Way & Round-Trip Package Options", 
            WhyChoosedescription: "Choose a one-way package when you only require transportation to another destination, or plan a round-trip package when you need the vehicle for your return journey. The arrangement can be discussed according to your itinerary and schedule." 
        }, 
        { 
            WhyChooseheading: "Suitable Vehicles for Families & Groups", 
            WhyChoosedescription: "Choose from suitable vehicle options based on passenger count, luggage quantity, and comfort requirements. Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles can be considered for different package requirements." 
        }, 
        { 
            WhyChooseheading: "Customized Multi-Day Travel Packages", 
            WhyChoosedescription: "Travellers planning extended pilgrimages or sightseeing tours can discuss multi-day cab packages covering multiple destinations. Overnight halts, sightseeing stops, return arrangements, and onward travel requirements can be included in the planned itinerary." 
        }, 
        { 
            WhyChooseheading: "Book Shirdi Cab Packages with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your pickup location, preferred destinations, travel dates, passenger count, luggage details, sightseeing requirements, trip duration, and vehicle preference with Sai Shirdi Cabs to plan a suitable private cab package." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "What types of Shirdi Cab Packages are available?", 
        answer: "Sai Shirdi Cabs provides private cab packages for Sai Baba Darshan, Shirdi sightseeing, airport transfers, nearby pilgrimage destinations, one-way trips, round trips, and customized outstation journeys." 
    }, 
    { 
        question: "Can I book a cab package for Sai Baba Darshan?", 
        answer: "Yes, devotees can book a private cab package for Sai Baba Darshan and combine the temple visit with local Shirdi sightseeing or nearby pilgrimage destinations." 
    }, 
    { 
        question: "Can I customize a Shirdi Cab Package?", 
        answer: "Yes, travellers can discuss their preferred destinations, sightseeing stops, travel dates, trip duration, overnight halts, return arrangements, and vehicle requirements while planning the package." 
    }, 
    { 
        question: "Do you provide outstation cab packages from Shirdi?", 
        answer: "Yes, outstation cab packages can be arranged from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Trimbakeshwar, Shani Shingnapur, Bhimashankar, and other locations." 
    }, 
    { 
        question: "Can I book a one-way Shirdi cab package?", 
        answer: "Yes, one-way packages are available for passengers who require direct transportation from Shirdi to another destination without needing the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I book a round-trip cab package from Shirdi?", 
        answer: "Yes, round-trip packages can be arranged for travellers who want transportation to their destination and back to Shirdi according to their planned schedule." 
    }, 
    { 
        question: "Which vehicles are available for Shirdi Cab Packages?", 
        answer: "Vehicle options may include Sedan Cars, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles depending on passenger count, luggage, and package requirements." 
    }, 
    { 
        question: "Can families and senior citizens book Shirdi cab packages?", 
        answer: "Yes, private cab packages are suitable for families and groups travelling with senior citizens because everyone can travel together in a dedicated vehicle." 
    }, 
    { 
        question: "Can I book a multi-day cab package from Shirdi?", 
        answer: "Yes, multi-day packages can be discussed for travellers planning extended pilgrimage or sightseeing tours covering multiple destinations and overnight stays." 
    }, 
    { 
        question: "How can I book Shirdi Cab Packages with Sai Shirdi Cabs?", 
        answer: "Share your pickup point, preferred destinations, travel dates, passenger details, luggage requirements, sightseeing plans, trip duration, and vehicle preference with Sai Shirdi Cabs to arrange a suitable package." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Mahesh Pawar", 
        feedback: "We selected a private Shirdi cab package for our family pilgrimage and sightseeing plans. It was convenient to keep all our travel requirements in one itinerary and travel together throughout the trip.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Radhika Patil", 
        feedback: "Our group planned Shirdi Darshan along with nearby sightseeing, so we chose a private cab package. Having one vehicle made it easier to manage our stops, luggage, and travel schedule.", 
        rating: 5 
    } 
];


    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi Cab Packages",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-cab-packages.webp",
  "description":
    "Book Shirdi Cab Packages with Sai Shirdi Cabs for convenient, comfortable, and reliable Shirdi sightseeing, Sai Baba Darshan, local tours, one-day trips, and outstation travel. Our Shirdi cab packages are suitable for pilgrims, families, couples, groups, and business travelers. Choose from Sedan, Ertiga, Innova, Innova Crysta, and Tempo Traveller vehicles with professional drivers, well-maintained cars, flexible pickup and drop locations, affordable fares, and easy booking assistance. Sai Shirdi Cabs makes Shirdi sightseeing and pilgrimage travel simple and hassle-free.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-cab-packages"
  }
};



    return (
        <div>


<Helmet>
  <title>Shirdi Cab Packages | Shirdi Taxi Packages | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi Cab Packages with Sai Shirdi Cabs for Sai Baba Darshan, local sightseeing, one-day tours and outstation trips. Choose comfortable cars, professional drivers, flexible travel options and affordable cab packages in Shirdi."
  />

  <meta
    name="keywords"
    content="Shirdi Cab Packages, Shirdi taxi packages, Shirdi cab tour packages, Shirdi taxi tour packages, Shirdi sightseeing cab package, Shirdi sightseeing taxi package, Shirdi darshan cab package, Shirdi darshan taxi package, Shirdi Sai Baba darshan cab package, Shirdi Sai Baba darshan taxi package, Shirdi local sightseeing package, Shirdi local cab package, Shirdi local taxi package, Shirdi one day cab package, Shirdi one day taxi package, Shirdi one day tour package, Shirdi cab package, Shirdi taxi package, Shirdi tour cab package, Shirdi tour taxi package, Shirdi pilgrimage cab package, Shirdi pilgrimage taxi package, Shirdi temple tour cab package, Shirdi temple tour taxi package, Sai Baba Darshan cab package Shirdi, Sai Baba Darshan taxi package Shirdi, Shirdi sightseeing cab booking, Shirdi sightseeing taxi booking, Shirdi Darshan cab booking, Shirdi Darshan taxi booking, Shirdi tour cab booking, Shirdi tour taxi booking, Shirdi cab booking, Shirdi taxi booking, cab booking in Shirdi, taxi booking in Shirdi, Shirdi cab service, Shirdi taxi service, Shirdi cab packages for family, Shirdi taxi packages for family, Shirdi group cab package, Shirdi group taxi package, Shirdi private cab package, Shirdi private taxi package, Shirdi family cab package, Shirdi family taxi package, Shirdi pilgrimage tour package, Shirdi pilgrimage tour cab, Shirdi pilgrimage tour taxi, Shirdi local tour package, Shirdi sightseeing tour package, Shirdi one day sightseeing cab, Shirdi one day sightseeing taxi, Shirdi full day cab package, Shirdi full day taxi package, Shirdi half day cab package, Shirdi half day taxi package, Shirdi airport cab package, Shirdi airport taxi package, Shirdi railway station cab package, Shirdi railway station taxi package, Shirdi outstation cab package, Shirdi outstation taxi package, Shirdi one way cab package, Shirdi one way taxi package, Shirdi round trip cab package, Shirdi round trip taxi package, affordable Shirdi cab packages, affordable Shirdi taxi packages, best Shirdi cab packages, best Shirdi taxi packages, Shirdi cab package price, Shirdi taxi package price, Shirdi cab package cost, Shirdi taxi package cost, Sedan cab package Shirdi, Ertiga cab package Shirdi, Innova cab package Shirdi, Innova Crysta cab package Shirdi, Tempo Traveller package Shirdi, Shirdi cab package with driver, Shirdi taxi package with driver, Shirdi tour package with cab, Shirdi tour package with taxi, Shirdi to Mumbai cab package, Shirdi to Mumbai taxi package, Shirdi to Pune cab package, Shirdi to Pune taxi package, Shirdi to Nashik cab package, Shirdi to Nashik taxi package, Shirdi to Aurangabad cab package, Shirdi to Aurangabad taxi package, Shirdi to Goa cab package, Shirdi to Goa taxi package, Sai Shirdi Cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirdicabbookingpackages;